module.exports = __webpack_public_path__ + "static/media/usuario.8754f5c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/usuario.svg
// module id = 2488
// module chunks = 0